import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-training',
  templateUrl: './training-communication-skill.component.html',
  styleUrls: ['./training-communication-skill.component.scss']
})
export class TrainingCommunicationSkillsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
